// extracted by mini-css-extract-plugin
module.exports = {"sideLeft":"z_bS","sideRight":"z_bT","main":"z_bV"};